__turbopack_context__.v({
  "bioText": "HomePage-module-scss-module__tv6tkq__bioText",
  "cardContent": "HomePage-module-scss-module__tv6tkq__cardContent",
  "cardImage": "HomePage-module-scss-module__tv6tkq__cardImage",
  "cardImageWrapper": "HomePage-module-scss-module__tv6tkq__cardImageWrapper",
  "cardTitle": "HomePage-module-scss-module__tv6tkq__cardTitle",
  "divider": "HomePage-module-scss-module__tv6tkq__divider",
  "emailText": "HomePage-module-scss-module__tv6tkq__emailText",
  "footnote": "HomePage-module-scss-module__tv6tkq__footnote",
  "footnoteRef": "HomePage-module-scss-module__tv6tkq__footnoteRef",
  "footnotes": "HomePage-module-scss-module__tv6tkq__footnotes",
  "headerSection": "HomePage-module-scss-module__tv6tkq__headerSection",
  "homePage": "HomePage-module-scss-module__tv6tkq__homePage",
  "links": "HomePage-module-scss-module__tv6tkq__links",
  "name": "HomePage-module-scss-module__tv6tkq__name",
  "nameSection": "HomePage-module-scss-module__tv6tkq__nameSection",
  "profilePic": "HomePage-module-scss-module__tv6tkq__profilePic",
  "projectCard": "HomePage-module-scss-module__tv6tkq__projectCard",
  "projectsSection": "HomePage-module-scss-module__tv6tkq__projectsSection",
  "sectionTitle": "HomePage-module-scss-module__tv6tkq__sectionTitle",
  "subhead": "HomePage-module-scss-module__tv6tkq__subhead",
});
